import React from "react";
import useTheme from "../../hook/useTheme";

/* THEMES-01 · Selector "Apariencia" para el dropdown de usuario del AdminNavbar.
   Interfaz simple (items de dropdown), no un modal nuevo. No va en el Sidebar. */

// El `value` (contrato persistido en localStorage["smartmedic.theme"]) NO cambia:
// clinical | blue | dark | system. Sólo cambia la etiqueta visible.
const THEME_OPTIONS = [
  { value: "clinical", label: "Clínico", hint: "Claro, limpio y equilibrado", icon: "mdi-white-balance-sunny" },
  { value: "blue", label: "Azul sereno", hint: "Mayor identidad visual", icon: "mdi-palette-outline" },
  { value: "dark", label: "Oscuro", hint: "Menor luminosidad", icon: "mdi-weather-night" },
  { value: "system", label: "Automático", hint: "Sigue la apariencia de tu dispositivo", icon: "mdi-monitor" },
];

export default function ThemeSelector() {
  const { themePreference, setTheme } = useTheme();

  return (
    <div className="theme-selector">
      <h6 className="dropdown-header">Apariencia</h6>
      {THEME_OPTIONS.map((opt) => {
        const selected = themePreference === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            className={`dropdown-item d-flex align-items-center justify-content-between${selected ? " active" : ""}`}
            aria-pressed={selected}
            onClick={() => setTheme(opt.value)}
          >
            <span className="d-flex flex-column">
              <span>
                <i className={`mdi ${opt.icon} me-1`} aria-hidden="true" />
                {opt.label}
              </span>
              <small className="text-muted">{opt.hint}</small>
            </span>
            {selected && <i className="mdi mdi-check ms-2" aria-hidden="true" />}
          </button>
        );
      })}
    </div>
  );
}

export { THEME_OPTIONS };
